module.exports = __webpack_public_path__ + "img/nivel-bronze.b51c2264.svg";